import { IAppender } from '../appender/i-appender';

export class LoggerConfig {
  appenders: IAppender[];
}
